// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".client-Features-Email-Email-module__root--s7f3Y {\n  height: 100%;\n}\n/*# sourceMappingURL=Email.module.css.map */", "",{"version":3,"sources":["webpack://./Email.module.less","webpack://./client/Features/Email/Email.module.less"],"names":[],"mappings":"AAAA;EACC,YAAA;ACCD;AACA,2CAA2C","sourcesContent":[".root {\n\theight: 100%;\n}",".root {\n  height: 100%;\n}\n/*# sourceMappingURL=Email.module.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "client-Features-Email-Email-module__root--s7f3Y"
};
export default ___CSS_LOADER_EXPORT___;
